<template>
  <div class="wrapper">
    <div>マップレポート一覧</div>
    <v-toolbar color="transparent" flat>
      <MapReportRequestButtonAdd @click="onButtonAddClicked()" />
      <v-spacer />
      <MapReportRequestSearchBox @onTextEnter="onTextEnter" />
      <PageSelect
        :value="mapReport"
        @input="pagination"
        style="width:160px;"
        class="pl-4"
      />
    </v-toolbar>
    <MapReportRequestList :items="mapReport.items" />
    <MapReportRequestModalAdd
      v-if="displayRequestAddModal"
      :visible="displayRequestAddModal"
      @clickExec="onSubmit"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import MapReportRequestButtonAdd from '@/components/Advertiser/Report/MapReport/MapReportRequestButtonAdd'
import MapReportRequestSearchBox from '@/components/Advertiser/Report/MapReport/MapReportRequestSearchBox'
import MapReportRequestModalAdd from '@/components/Advertiser/Report/MapReport/MapReportRequestModalAdd'
import MapReportRequestList from '@/components/Advertiser/Report/MapReport/MapReportRequestList'
import PageSelect from '@/components/Shared/Search/PageSelect'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import { mapActions, mapGetters } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'MapReport',
  components: {
    MapReportRequestButtonAdd,
    MapReportRequestSearchBox,
    MapReportRequestList,
    MapReportRequestModalAdd,
    PageSelect,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      mapReportObject: {},
      displayRequestAddModal: false,
    }
  },
  computed: {
    ...mapGetters('mapReport', [
      'keyword',
      'advertiserId',
      'pageNo',
      'mapReport',
    ]),
  },
  created() {
    this.initSearch()
  },
  beforeDestroy() {
    this.reset()
  },
  methods: {
    ...mapActions('mapReport', {
      initSearchItems: 'INIT_SEARCH_ITEMS',
      setSearchKeyword: 'SET_SEARCH_KEYWORD',
      setPageNo: 'SET_SEARCH_PAGE_NO',
      setMapReport: 'SET_MAP_REPORT',
      reset: 'RESET',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    updateMapReport() {
      this.setMapReport({
        keyword: this.keyword,
        advertiserId: this.advertiserId,
        pageNo: this.pageNo,
      })
    },
    initSearch() {
      this.initSearchItems(this.$route.params.advertiserId)
      this.updateMapReport()
    },
    onTextEnter(searchWord) {
      this.setSearchKeyword(searchWord)
      this.updateMapReport()
    },
    pagination(pageNo) {
      this.setPageNo(pageNo)
      this.updateMapReport()
    },
    onButtonAddClicked() {
      this.displayRequestAddModal = true
    },
    onSubmit() {
      this.displayRequestAddModal = false
      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: 'マップレポート申請を登録しました。',
      })
      this.initSearch()
    },
    cancel() {
      this.displayRequestAddModal = false
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
</style>
